(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'bannerSubtitle', {
            bindings: {},
            templateUrl:    'app/views/partials/widgets/banner-subtitle.html',
            controller:     BannerSubtitleController,
            controllerAs:   'vm'
        });


    /**
     * Render degree page's subtitle with information about pre-selected majors.
     *
     * Note: Works for Degrees *ONLY* -> If it needs to be extended for programmes, more logic is required
     *
     * @param {ng.IScope} $scope
     * @param {SelectablesService} SelectablesService
     * @param {Object} CONFIG
     * @param {Object} TEXTS
     */
    function BannerSubtitleController(
        $scope,
        SelectablesService,
        CONFIG,
        TEXTS
    ){
        // Helping members.

        /** @type {angular.IController} */
        var vm = this;


        // Expose to the Scope.

        $scope.CONFIG   = CONFIG;
        $scope._        = TEXTS.DEGREE.BANNER_SUBTITLE;


        /** @constructor */
        vm.$onInit = function() {
            setWatchers();
        };


        /** Private functions. */

        function setWatchers() {

            $scope.$watch( function() { return SelectablesService.selectablesCreatedCount; }, function( isInitialised ) {
                if ( !isInitialised ) return;


                /** @type {Selectables} */
                var degreeSelectables = SelectablesService.getSelectablesById( 'degreeMajors' );
                vm.itemsModel = degreeSelectables.model;
            });

        }
    }


    BannerSubtitleController.$inject = [ '$scope', 'SelectablesService', 'CONFIG', 'TEXTS' ];
})();
